var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 47,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#172B85",
    fillRule: "evenodd",
    d: "M21.25 32.517h-4.24l-3.18-12.132c-.151-.558-.472-1.052-.943-1.284-1.176-.584-2.473-1.05-3.887-1.284v-.467h6.831c.943 0 1.65.701 1.768 1.516l1.65 8.751 4.239-10.267h4.122zm8.718 0h-4.005L29.26 17.35h4.005zm8.48-10.966c.117-.816.824-1.283 1.65-1.283 1.295-.118 2.708.117 3.886.7l.707-3.266A10.1 10.1 0 0 0 41.04 17c-3.887 0-6.716 2.1-6.716 5.017 0 2.218 2.004 3.382 3.418 4.084 1.53.7 2.12 1.166 2.002 1.866 0 1.05-1.179 1.517-2.355 1.517-1.415 0-2.829-.35-4.123-.935l-.707 3.268c1.414.582 2.944.817 4.358.817 4.359.115 7.067-1.984 7.067-5.134 0-3.967-5.537-4.2-5.537-5.949M58 32.516 54.82 17.35h-3.415c-.707 0-1.415.467-1.65 1.166l-5.889 14h4.123l.823-2.216h5.066l.47 2.216zm-6.006-11.082 1.176 5.716h-3.298z",
    clipRule: "evenodd"
  })));
};
export default SvgVisa;